import { Menu, MenuButton, MenuList, IconButton, MenuDivider, MenuItem } from '@chakra-ui/react'
import { IProvider } from '@/shared/IProvider'
import { FiEdit2, FiExternalLink, FiMail, FiMoreHorizontal, FiX } from 'react-icons/fi'
import { runtimeConfig } from '../services/RuntimeConfig'

import { createColumnHelper } from "@tanstack/react-table";
import { DataTable } from "./DataTable";
import { highlightText } from '@/shared/parse';
import { EmailLink } from '../components/EmailLink';
import { HighlightedText } from '../components/HighlightedText';

export const ProviderTable = (props: {
  filter: string[];
  providers: IProvider[];
  onDeleteProvider: (provider: IProvider) => void;
  onSendInvitation: (provider: IProvider) => Promise<void>;
  onEditProvider: (provider: IProvider) => void;
}) => {

  const openSharePointFolder = (provider: IProvider) => {
    let url = `${runtimeConfig.spSiteUrl}/Lists/Providers/DispForm.aspx?ID=${provider.id}`;
    window.open(url, `provider-${provider.id}`);
  }

  const columnHelper = createColumnHelper<IProvider>();

  const columns = [
    columnHelper.accessor("id", {
      header: "ID",
      cell: (info) => {
        const provider = info.row.original;
        return (
          <Menu>
            <MenuButton as={IconButton} variant='ghost' icon={<FiMoreHorizontal />} cursor='pointer' boxSize="10" />
            <MenuList fontSize='medium' lineHeight={1.5}>
              <MenuItem icon={<FiEdit2 />} onClick={() => props.onEditProvider(provider)}>Edit...</MenuItem>
              <MenuDivider />
              <MenuItem icon={<FiMail />} onClick={() => props.onSendInvitation(provider)}>Resend Invitation</MenuItem>
              <MenuItem icon={<FiExternalLink />} onClick={() => openSharePointFolder(provider)}>Open in SharePoint...</MenuItem>
              <MenuDivider />
              <MenuItem icon={<FiX />} onClick={() => props.onDeleteProvider(provider)}>Delete...</MenuItem>
            </MenuList>
          </Menu>
        )
      },
      enableSorting: false,
      enableHiding: false,
      size: 10
    }),
    columnHelper.accessor('ProviderIdentifier', {
      cell: (info) => {
        const provider = info.row.original;
        return (
          <HighlightedText text={provider.ProviderIdentifier} filter={props.filter} />
        )
      },
      header: "Identifier"
    }),
    columnHelper.accessor('ProviderName', {
      cell: (info) => {
        const provider = info.row.original;
        return <HighlightedText text={provider.ProviderName} filter={props.filter} />
      },
      header: "Name"
    }),
    columnHelper.accessor('ProviderContact', {
      cell: (info) => {
        const provider = info.row.original;
        return <EmailLink email={provider.ProviderEmail} name={highlightText(provider.ProviderContact, props.filter)} />
      },
      header: "Primary Contact"
    }),
    columnHelper.accessor('ProviderUsers', {
      cell: (info) => {
        const provider = info.row.original;
        return (provider.ProviderUsers ?? []).map(u => <EmailLink key={u.id} email={u.email} name={highlightText(u.name, props.filter)} />)
      },
      header: "Additional Contacts"
    }),
    columnHelper.accessor('ProviderAddress', {
      cell: (info) => {
        const provider = info.row.original;
        return <HighlightedText text={provider.ProviderAddress} filter={props.filter} />
      },
      header: "Address"
    }),
    columnHelper.accessor('ProviderPhone', {
      cell: (info) => {
        const provider = info.row.original;
        return <HighlightedText text={provider.ProviderPhone} filter={props.filter} />
      },
      header: "Phone"
    }),
    columnHelper.accessor('ProviderWebsite', {
      cell: (info) => {
        const provider = info.row.original;
        return provider.ProviderWebsite ? (
          <a href={provider.ProviderWebsite.startsWith('http') ? provider.ProviderWebsite : `https://${provider.ProviderWebsite}`} target="_blank" rel="noopener noreferrer">{highlightText(provider.ProviderWebsite, props.filter)}</a>
        ) : null;
      },
      header: "Website"
    }),
    columnHelper.accessor('ProviderCountry', {
      cell: (info) => {
        const provider = info.row.original;
        return <HighlightedText text={provider.ProviderCountry} filter={props.filter} />
      },
      header: "Country"
    }),
    // columnHelper.accessor("modified", {
    //   cell: (info) => {
    //     const course = info.row.original;
    //     return formatDate(course.modified)
    //   },
    //   header: "Modified"
    // }),
    // columnHelper.accessor("modifiedBy", {
    //   cell: (info) => {
    //     const course = info.row.original;
    //     return course.modifiedBy?.name
    //   },
    //   header: "Modified By"
    // })

  ];


  return (
    <DataTable
      onRowClick={props.onEditProvider}
      emptyLabel='No providers to show here yet'
      columns={columns}
      data={props.providers}
    />
  )
}